import styled from 'styled-components';

import { Hero as XingternalHero } from '@xingternal/typography';

import { scale140, scale260, xdlColorXING } from '@xingternal/tokens';

import { sectionInnerContainerMixin, sectionMixin } from '../variables.style';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: ${xdlColorXING};
  padding-top: ${scale260};
  padding-bottom: ${scale260};
  ${sectionMixin}
`;

export const Hero = styled(XingternalHero)`
  margin-bottom: ${scale140};
`;

export const InnerContainer = styled.div`
  ${sectionInnerContainerMixin};
`;
